// extracted by mini-css-extract-plugin
module.exports = {" _key":"sitepen-site/BlogPreviewList","root":"BlogPreviewList-m__root__f52bc33L_2y","item":"BlogPreviewList-m__item__f52bc3Iu4fk"};